import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ParkAboutSectionSkeleton = () => {
  return (
    <div
      className="about_title pb-4"
      style={{ borderBottom: "1px solid #0000004D" }}
    >
      <Skeleton height={28} width={300} className="mb-3" />
      <Skeleton count={5} />
      <Skeleton count={5} className="mt-2"/>
      <Skeleton count={5} className="mt-2"/>
    </div>
  );
};

export default ParkAboutSectionSkeleton;
